import { render, staticRenderFns } from "./SyrupPowder.vue?vue&type=template&id=2cfae6d4&scoped=true&"
import script from "./SyrupPowder.vue?vue&type=script&lang=js&"
export * from "./SyrupPowder.vue?vue&type=script&lang=js&"
import style0 from "./SyrupPowder.vue?vue&type=style&index=0&id=2cfae6d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfae6d4",
  null
  
)

export default component.exports